import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, inject, input, output, signal } from '@angular/core';
import Language from '../../models/Language.model';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './language-selector.html',
})
export class LanguageSelectorComponent {
  availableLanguages = input.required<Language[]>();
  activeMenuLanguage = input.required<Language | undefined>();
  languageChange = output<string>();

  public isOpen = signal(false);
  private elementRef = inject(ElementRef);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
    }
  }

  toggleDropdown(): void {
    this.isOpen.set(!this.isOpen());
  }

  selectLanguage(langId: string): void {
    this.languageChange.emit(langId);
    this.isOpen.set(false);
  }
}
